import {loadFile} from './loaderUtils'
import * as THREE from 'three'

class MaterialXMLParcer{
  constructor(){

  }

  async Request(path){


  }

  async Load(path){
    // ファイルリクエスト
    const xmlText = await loadFile(path);

    // パスを/で分割して、末尾を削除しディレクトリに
    const pathDirArr = path.split('/');
    pathDirArr.pop();
    // joinでつなげる(join)
    const pathDir = pathDirArr.join('/')+'/';

    // xmlをパース
    const parser = new DOMParser();
    const xml = parser.parseFromString(xmlText,"text/xml");
    console.log(xml)

    // パラメータ取得
    const layer = xml.getElementsByTagName('Layer')[0]; // 複数ある場合未対応
    const albedo = layer.querySelector('Component[target="Albedo"]')
    const normal = layer.querySelector('Component[target="Normal"]')

    // todo他にも必要なパラメータを取得

    // albedoテクスチャ
    let albedoParam = {};
    if(albedo){
      if(albedo.getElementsByTagName('Zipped').length > 0){
        // xmlに書かれいるパスに'\domain\'という使わないパスが含まれているので削除してディレクトリに置換
        let imagePath = albedo.getElementsByTagName('Zipped')[0].getAttribute("absolutePath");
        imagePath = imagePath.replace('\\domain\\', pathDir);
        albedoParam.resourcePath = imagePath; 
        albedoParam.resourceId = albedo.getElementsByTagName('NodeReference')[0].getAttribute("id");
      }
      albedoParam.colorR = albedo.querySelector('Attribute[name="ConstantColor.r"]').getAttribute("value");
      albedoParam.colorG = albedo.querySelector('Attribute[name="ConstantColor.g"]').getAttribute("value");
      albedoParam.colorB = albedo.querySelector('Attribute[name="ConstantColor.b"]').getAttribute("value");
      albedoParam.colorA = albedo.querySelector('Attribute[name="ConstantColor.a"]').getAttribute("value");
    }
    // normalテクスチャ
    let normalParam = {};
    if(normal){
      if(normal.getElementsByTagName('Zipped').length > 0){
        // xmlに書かれいるパスに'\domain\'という使わないパスが含まれているので削除してディレクトリに置換
        let imagePath = normal.getElementsByTagName('Zipped')[0].getAttribute("absolutePath");
        imagePath = imagePath.replace('\\domain\\', pathDir);
        normalParam.resourcePath = imagePath; 
        normalParam.resourceId = normal.getElementsByTagName('NodeReference')[0].getAttribute("id");
      }
      normalParam.colorR= normal.querySelector('Attribute[name="ConstantColor.r"]').getAttribute("value");
      normalParam.colorG = normal.querySelector('Attribute[name="ConstantColor.g"]').getAttribute("value");
      normalParam.colorB = normal.querySelector('Attribute[name="ConstantColor.b"]').getAttribute("value");
      normalParam.colorA = normal.querySelector('Attribute[name="ConstantColor.a"]').getAttribute("value");
    }

    await Promise.all([this.loadImageXML(albedoParam, pathDir), 
                      this.loadImageXML(normalParam, pathDir)
                    ]);

    // three.jsのマテリアル作成時の引数にあわせて戻り値をつくる(画像パスは除く)
    return {
      color: new THREE.Color( albedoParam.colorR, albedoParam.colorG, albedoParam.colorB),
      map: null,
      mapPath: albedoParam.imagePath,
      mapExt: albedoParam.imageExt,
      normalMap: null,
      normalMapPath: normalParam.imagePath,
      normalMapExt: normalParam.imageExt,
      specular: new THREE.Color(0,0,0),
    }

  }

  async loadImageXML(param, pathDir){
    if(param.resourcePath === undefined)
      return;
    console.log("a",param.resourcePath)
    const xmlText = await loadFile(param.resourcePath);

    // xmlをパース
    const parser = new DOMParser();
    const xml = parser.parseFromString(xmlText,"text/xml");

    const node = xml.getElementById(param.resourceId);

    // xmlに書かれいるパスに'\Import\'という使わないパスが含まれているので削除してディレクトリに置換
    let imagePath = node.getElementsByTagName('Zipped')[0].getAttribute("absolutePath");
    imagePath = imagePath.replace('\\Import\\', pathDir);

    // ddsを読むと以下のようなエラーが出たので.ddsを.pngに 
    // DDSLoader.js:150 THREE.DDSLoader.parse: Invalid magic number in DDS header.
    imagePath = imagePath.replace('.dds', '.png')
    imagePath = imagePath.replace('.DDS', '.png')
    param.imagePath = imagePath;
    
    // image ext
    param.imageExt = imagePath.split('/').pop().split('.').pop();
    
  }
}

export default new MaterialXMLParcer();
